import { render, staticRenderFns } from "./SectionIndicator.vue?vue&type=template&id=7f070b52&"
import script from "./SectionIndicator.vue?vue&type=script&lang=js&"
export * from "./SectionIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports